mutation UpsertParameterGroup (
    $id: ID
    $definition: ParameterGroupDefinition!
    $tier: EnumAccessTier
) {
    upsertParameterGroup(
        id: $id
        definition: $definition
        tier: $tier
    ) {
        errors {
            message
            path
        }
        parameterGroup {
            id
            name {
                language
                text
            }
            order
            tier
        }
    }
}
